import TooltipBase from "components/Tooltip/TooltipBase";
import { Loading } from "components/panels";
import React, { useContext } from "react";
import { FilterContext } from "./FilterContext";
import { HorizontalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";

interface Props {
  content: JSX.Element
  filterButtonLabel: string

  open?: boolean
  width?: number
  onOpen?: () => void
  onClose?: () => void
  isLoading?: boolean
}

const FilterPopup = (props: Props) => {
  const { filterPopupPosition } = useContext(FilterContext);

  return <TooltipBase
    trigger={<a {...HorizontalKeyboardNavigationGroup("filterHeader")} tabIndex={0} className="filter_link">{props.filterButtonLabel}</a>}
    position={filterPopupPosition === "bottom" ? "bottom center" : "left center"}
    onOpen={props.onOpen}
    onClose={props.onClose}
    open={props.open}
    width={props.width}
    tooltipStyle={{ minHeight: 0 }}
  >
    <div className="padding-larger">
      {props.isLoading
        ? <Loading />
        : props.content
      }
    </div>
  </TooltipBase>
}

export default FilterPopup;